export enum ClearableKeys {
  DELETE="Delete",
  BACKSPACE="Backspace"
}
